import { BCMSRecord, Link, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import { SVGAsset } from "res";

import "./styles.css";

export default function SelectAccountContent(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return (
        <div className="select-account-content back-link-padding">
            <Link to="/advancedAlerts/addAlert" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Select Account</p>

            <div className="flex-container flex-vertical select-account-container">
                { Account.initAll().map(account => {
                    return <SelectAccountItem account={ account } />
                }, []) }
            </div>
        </div>
    );
}

function SelectAccountItem(props) {
    const navigate = useRoute();

    const { account } = props ?? {};
    const { balanceLabel, availableBalance, currentBalance, type, nickname, number } = account ?? {};

    const amount = type === "loan" || type === "loc" ? currentBalance.format() : availableBalance.format();
    const onClick = evt => navigate(`/advancedAlerts/addAlertBelowThreshold/${ account.id }`);

    return (
        <div className="flex-container flex-horizontal account-item clickable" onClick={ onClick }>
            <div className="flex-container flex-vertical flex-width">
                <p className="account-name">{ nickname } { number }</p>
                <p className="account-balance">{ balanceLabel }|{ amount }</p>
            </div>

            <SVGAsset id="RightChevronIcon" className="set-width" />
        </div>
    );
}